import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/src/app/(components)/CmsBlocks/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorSection"] */ "/src/app/(components)/ErrorSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/src/app/(components)/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Section"] */ "/src/app/(components)/SectionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhoneAndMail"] */ "/src/app/(components)/shared/PhoneAndMail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/app/(components)/shared/Spaces.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutFAQ"] */ "/src/app/(pages)/services/components/AboutFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicCardsSection"] */ "/src/app/(pages)/services/components/DynamicCardsSection.tsx");
